// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { WebService } from "../../Services/WebService";
// import { PageInfo } from "../PageInfo";
// import StaticListComponent from "../../Services/StaticListComponent";
// import { StandardConst } from "../../Services/StandardConst";
// import { NoRecordTemplate } from "../../Services/TableComponent";
// import { Chip, Tooltip } from "@mui/material";
// import ActionButton from "../../Services/ActionButton";
// import { Button, Card, Tabs, Tab } from "react-bootstrap";

// const MyBroadcastDocuments = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [allDocuments, setAllDocuments] = useState([]);
//   const [activeTab, setActiveTab] = useState("pending");
//   const [isLoading, setIsLoading] = useState(false);
//   const UserInfo = useSelector((s) => s.auth.BasicInfo ?? {});

//   PageInfo({ pageTitle: "My Documents" });

//   const [bData] = React.useState([
//     {
//       title: "My Documents",
//       hrefLink: "/MyDocuments",
//     },
//     {
//       title: "",
//       hrefLink: "",
//     },
//   ]);

//   // useEffect(() => {
//   //   fetchMyDocuments();
//   // }, []);

//   useEffect(() => {
//   if (UserInfo?.EmployeeId) {
//     fetchMyDocuments(UserInfo.EmployeeId);
//   }
// }, [UserInfo?.EmployeeId]);
// console.log(UserInfo.EmployeeId);

// const fetchMyDocuments = async (employeeId) => {
//   if (!employeeId) return;

//   setIsLoading(true);
//   try {
//     const result = await WebService({
//       endPoint: `Document/GetMyDocuments/${employeeId}`,
//       method: "GET",
//       dispatch,
//     });

//     if (result?.result) {
//       setAllDocuments(result.result);
//     }
//   } catch (error) {
//     console.error("Error fetching documents:", error);
//   } finally {
//     setIsLoading(false);
//   }
// };

//   // const fetchMyDocuments = async () => {
//   //   setIsLoading(true);
//   //   try {
//   //     const result = await WebService({
//   //       endPoint: `Document/GetMyDocuments/${UserInfo.EmployeeId}`,
//   //       method: "GET",
//   //       dispatch,
//   //     });

//   //     if (result?.result) {
//   //       setAllDocuments(result.result);
//   //     }
//   //   } catch (error) {
//   //     console.error("Error fetching documents:", error);
//   //   } finally {
//   //     setIsLoading(false);
//   //   }
//   // };

//   function beautifyLocalTime(utcTimestamp) {
//     if (!utcTimestamp) return '-';
//     const utcDate = new Date(utcTimestamp);
//     const options = {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: 'numeric',
//       minute: 'numeric',
//       hour12: true,
//     };
//     return new Intl.DateTimeFormat(undefined, options).format(utcDate);
//   }

//   const getStatusChip = (status, requireSignature) => {
//     const statusConfig = {
//       'Pending': { color: 'warning', label: 'Action Required' },
//       'Acknowledged': { color: 'success', label: 'Acknowledged' },
//       'Signed': { color: 'success', label: 'Signed' },
//       'Sent': { color: 'info', label: 'Sent' },
//     };

//     const config = statusConfig[status] || statusConfig['Pending'];
    
//     return (
//       <Chip
//         label={config.label}
//         size="small"
//         color={config.color}
//       />
//     );
//   };

//   const getPriorityIcon = (doc) => {
//     if (doc.RequireSignature) {
//       return (
//         <Tooltip title="Signature Required">
//           <span className="badge bg-danger ms-2">✍️ Sign Required</span>
//         </Tooltip>
//       );
//     } else if (doc.RequireAcknowledgment) {
//       return (
//         <Tooltip title="Acknowledgment Required">
//           <span className="badge bg-warning ms-2">⚠️ Ack Required</span>
//         </Tooltip>
//       );
//     }
//     return null;
//   };

//   // Filter documents based on active tab
//   const filteredDocuments = allDocuments.filter(doc => {
//     if (activeTab === "pending") {
//       return doc.Status === "Pending" || doc.Status === "Sent";
//     } else {
//       return doc.Status === "Acknowledged" || doc.Status === "Signed";
//     }
//   });

//   const pendingCount = allDocuments.filter(doc => 
//     doc.Status === "Pending" || doc.Status === "Sent"
//   ).length;

//   const completedCount = allDocuments.filter(doc => 
//     doc.Status === "Acknowledged" || doc.Status === "Signed"
//   ).length;

//   const columns = [
//     {
//       Text: "Document Title",
//       Value: "Title",
//       render: (dr) => (
//         <div>
//           <strong>{dr.Title}</strong>
//           {getPriorityIcon(dr)}
//           {dr.Label && (
//             <>
//             <br />
//             <small className="text-muted">{dr.Label.substring(0, 60)}{dr.Label.length > 60 ? '...' : ''}</small>
//             </>
//           )}
//         </div>
//       )
//     },
//     {
//       Text: "Sent By",
//       Value: "CreaterName",
//       render: (dr) => (
//         <div>
//           <div>{dr.CreaterName}</div>
//           <small className="text-muted">{beautifyLocalTime(dr.SentAt)}</small>
//         </div>
//       )
//     },
//     {
//       Text: "Status",
//       Value: "Status",
//       cssClass: "text-center",
//       render: (dr) => (
//         <div>
//           {getStatusChip(dr.Status, dr.RequireSignature)}
//           {dr.AcknowledgedAt && (
//             <>
//               <br />
//               <small className="text-muted">
//                 {beautifyLocalTime(dr.AcknowledgedAt)}
//               </small>
//             </>
//           )}
//         </div>
//       )
//     },
//     {
//       Text: "Action",
//       cssClass: "text-center td-width-100",
//       render: (dr) => (
//         <span className="d-flex col-auto">
//           {(dr.Status === "Pending" || dr.Status === "Sent") ? (
//             <>
//               <ActionButton
//                 IconTooltip="View & Sign Document"
//                 IconName="Visibility"
//                 IconColor="primary"
//                 onClick={() => navigate(`/ViewDocument/${dr.BroadcastDocumentId}`)}
//               />
//               <ActionButton
//                 IconName='Download'
//                 IconTooltip='Download Document'
//                 onClick={() =>
//                   window.open(
//                     `${StandardConst.apiBaseUrl}/${dr.DocumentPath}`,
//                     "_blank"
//                   )
//                 }
//               />
//             </>
//           ) : (
//             <>
//               <ActionButton
//                 IconTooltip="View Document"
//                 IconName="Visibility"
//                 IconColor="success"
//                 onClick={() => navigate(`/ViewDocument/${dr.BroadcastDocumentId}`)}
//               />
//               <ActionButton
//                 IconName='Download'
//                 IconTooltip='Download Document'
//                 onClick={() =>
//                   window.open(
//                     `${StandardConst.apiBaseUrl}/${dr.DocumentPath}`,
//                     "_blank"
//                   )
//                 }
//               />
//               {dr.SignaturePath && (
//                 <ActionButton
//                   IconName='Badge'
//                   IconTooltip='View My Signature'
//                   IconColor="info"
//                   onClick={() =>
//                     window.open(
//                       `${StandardConst.apiBaseUrl}/${dr.SignaturePath}`,
//                       "_blank"
//                     )
//                   }
//                 />
//               )}
//             </>
//           )}
//         </span>
//       ),
//     },
//   ];

//   return (
//     <>
//       {/* Statistics Card */}
//       <Card className="mb-3 shadow-sm">
//         <Card.Body>
//           <div className="row text-center">
//             <div className="col-md-3">
//               <div className="p-3">
//                 <h2 className="text-primary mb-0">{allDocuments.length}</h2>
//                 <small className="text-muted">Total Documents</small>
//               </div>
//             </div>
//             <div className="col-md-3">
//               <div className="p-3">
//                 <h2 className="text-warning mb-0">{pendingCount}</h2>
//                 <small className="text-muted">Pending Action</small>
//               </div>
//             </div>
//             <div className="col-md-3">
//               <div className="p-3">
//                 <h2 className="text-success mb-0">{completedCount}</h2>
//                 <small className="text-muted">Completed</small>
//               </div>
//             </div>
//             <div className="col-md-3">
//               <div className="p-3">
//                 <h2 className="text-info mb-0">
//                   {allDocuments.length > 0 
//                     ? Math.round((completedCount / allDocuments.length) * 100) 
//                     : 0}%
//                 </h2>
//                 <small className="text-muted">Completion Rate</small>
//               </div>
//             </div>
//           </div>
//         </Card.Body>
//       </Card>

//       {/* Tabs for Pending and Completed */}
//       <Card className="shadow-sm">
//         <Card.Header>
//           <Tabs
//             activeKey={activeTab}
//             onSelect={(k) => setActiveTab(k)}
//             className="mb-0"
//           >
//             <Tab 
//               eventKey="pending" 
//               title={
//                 <span>
//                   📋 Pending ({pendingCount})
//                 </span>
//               }
//             />
//             <Tab 
//               eventKey="completed" 
//               title={
//                 <span>
//                   ✓ Completed ({completedCount})
//                 </span>
//               }
//             />
//           </Tabs>
//         </Card.Header>
//         <Card.Body className="p-0">
//           <StaticListComponent
//             columns={columns}
//             data={filteredDocuments}
//             bData={bData}
//             MasterPageName={activeTab === "pending" ? "Pending Documents" : "Completed Documents"}
//             noRecordCss="p-0"
//             noRecordFound={
//               <NoRecordTemplate
//                 headerValue={
//                   activeTab === "pending" 
//                     ? "No Pending Documents" 
//                     : "No Completed Documents"
//                 }
//                 subHeaderValue={
//                   activeTab === "pending"
//                     ? "You're all caught up! No documents require your action."
//                     : "You haven't completed any documents yet."
//                 }
//                 imageUrl={StandardConst.imageNoRecordsFound}
//               />
//             }
//             IsAddButtonVisible={false}
//             isSearchRequired={true}
//             allowSerialNo={true}
//           />
//         </Card.Body>
//       </Card>
//     </>
//   );
// };

// export default MyBroadcastDocuments;







import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { WebService } from "../../Services/WebService";
import { PageInfo,ActionPermission } from "../PageInfo";
import StaticListComponent from "../../Services/StaticListComponent";
import { StandardConst } from "../../Services/StandardConst";
import { NoRecordTemplate } from "../../Services/TableComponent";
import { Chip, Tooltip } from "@mui/material";
import ActionButton from "../../Services/ActionButton";
import { Card } from "react-bootstrap";


const MyBroadcastDocuments = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [allDocuments, setAllDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [permission, SetPermission] = useState({});
  const UserInfo = useSelector((s) => s.auth.BasicInfo ?? {});
   const permissionList = useSelector((s) => s.auth.PermissionList ?? []);

  PageInfo({ pageTitle: "My Documents" });

  const [bData] = React.useState([
    {
      title: "My Documents",
      hrefLink: "/MyDocuments",
    },
    {
      title: "",
      hrefLink: "",
    },
  ]);

  useEffect(() => {
    if (UserInfo?.EmployeeId) {
      fetchMyDocuments(UserInfo.EmployeeId);
    }
  }, [UserInfo?.EmployeeId]);

    useEffect(() => {
      
      SetPermission({
    
        ManageView: ActionPermission("Policy Document - View"),
      });
    }, [permissionList]);

  const fetchMyDocuments = async (employeeId) => {
    if (!employeeId) return;

    setIsLoading(true);
    try {
      const result = await WebService({
        endPoint: `Document/GetMyDocuments/${employeeId}`,
        method: "GET",
        dispatch,
      });

      if (result?.result) {
      console.log(result?.result);
        setAllDocuments(result.result);
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setIsLoading(false);
    }
  };

  function beautifyLocalTime(utcTimestamp) {
    if (!utcTimestamp) return '-';
    const utcDate = new Date(utcTimestamp);
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    return new Intl.DateTimeFormat(undefined, options).format(utcDate);
  }

  const getStatusChip = (status, requireSignature) => {
    const statusConfig = {
      'Pending': { color: 'warning', label: 'Action Required' },
      'Acknowledged': { color: 'success', label: 'Acknowledged' },
      'Signed': { color: 'success', label: 'Signed' },
      'Sent': { color: 'info', label: 'Pending' },
    };

    const config = statusConfig[status] || statusConfig['Pending'];
    
    return (
      <Chip
        label={config.label}
        size="small"
        color={config.color}
      />
    );
  };

  const getPriorityIcon = (doc) => {
    if (doc.RequireSignature) {
      return (
        <Tooltip title="Signature Required">
          <span className="badge bg-danger ms-2">✍️ signature Required</span>
        </Tooltip>
      );
    } else if (doc.RequireAcknowledgment) {
      return (
        <Tooltip title="Acknowledgment Required">
          <span className="badge bg-warning ms-2">⚠️ Ack Required</span>
        </Tooltip>
      );
    }
    return null;
  };

  const pendingCount = allDocuments.filter(doc => 
    doc.Status === "Pending" || doc.Status === "Sent"
  ).length;

  const completedCount = allDocuments.filter(doc => 
    doc.Status === "Acknowledged" || doc.Status === "Signed"
  ).length;
// console.log(allDocuments,'abhi-----');
  const columns = [
    {
      Text: "Document Title",
      Value: "Title",
      exportValue: (dr) => {
        return dr.Title ? dr.Title : '';
      },
      render: (dr) => (
        <div>
          <strong>{dr.Title}</strong>
          {getPriorityIcon(dr)}
          {dr.Label && (
            <>
            <br />
            <small className="text-muted">{dr.Label.substring(0, 60)}{dr.Label.length > 60 ? '...' : ''}</small>
            </>
          )}
        </div>
      )
    },
    {
      Text: "Sent By",
      Value: "CreaterName",
      exportValue: (dr) => {
        return dr.CreaterName ? dr.CreaterName : '';
      },
      render: (dr) => (
        <div>
          <div>{dr.CreaterName}</div>
          <small className="text-muted">{beautifyLocalTime(dr.SentAt)}</small>
        </div>
      )
    },
    {
      Text: "Status",
      Value: "Status",
      cssClass: "text-center",
      exportValue: (dr) => {
        return `${dr.Status === 'Sent' ? 'pending' : (dr.Status || '')}  ${dr.RequireSignature ? '(RequireSignature)' : ''}` ;
      },
      render: (dr) => (
        <div>
          {/* {console.log(dr)} */}
          {getStatusChip(dr.Status, dr.RequireSignature)}
          {dr.AcknowledgedAt && (
            <>
              <br />
              <small className="text-muted">
                {beautifyLocalTime(dr.AcknowledgedAt)}
              </small>
            </>
          )}
        </div>
      )
    },
    {
      Text: "Action",
      cssClass: "text-center td-width-100",
      render: (dr) => (
        <span className="d-flex col-auto">
          {(dr.Status === "Pending" || dr.Status === "Sent") ? (
            <>
              <ActionButton
                IconTooltip="View & Sign Document"
                IconName="Visibility"
                IconColor="primary"
                onClick={() => navigate(`/ViewDocument/${dr.BroadcastDocumentId}`)}
              />
              <ActionButton
                IconName='Download'
                IconTooltip='Download Document'
                onClick={() =>
                  window.open(
                    `${StandardConst.apiBaseUrl}/uploads/${dr.DocumentPath}`,
                    "_blank"
                  )
                }
              />
            </>
          ) : (
            <>
              <ActionButton
                IconTooltip="View Document"
                IconName="Visibility"
                IconColor="success"
                onClick={() => navigate(`/ViewDocument/${dr.BroadcastDocumentId}`)}
              />
              <ActionButton
                IconName='Download'
                IconTooltip='Download Document'
                onClick={() =>
                  window.open(
                    `${StandardConst.apiBaseUrl}/uploads/${dr.DocumentPath}`,
                    "_blank"
                  )
                }
              />
              {dr.SignaturePath && (
                <ActionButton
                  IconName='Badge'
                  IconTooltip='View My Signature'
                  IconColor="info"
                  onClick={() =>
                    window.open(
                      `${StandardConst.apiBaseUrl}/${dr.SignaturePath}`,
                      "_blank"
                    )
                  }
                />
              )}
            </>
          )}
        </span>
      ),
    },
  ];

  // Statistics Component to be added in the header
  const StatisticsCard = () => (
    <Card className="shadow-sm" style={{ fontSize: '0.85rem' }}>
      <Card.Body className="p-2">
        <div className="d-flex gap-3">
          <div className="text-center px-2">
            <div className="fw-bold text-primary" style={{ fontSize: '1.2rem' }}>{allDocuments.length}</div>
            <small className="text-muted" style={{ fontSize: '0.7rem' }}>Total</small>
          </div>
          <div className="text-center px-2 border-start">
            <div className="fw-bold text-warning" style={{ fontSize: '1.2rem' }}>{pendingCount}</div>
            <small className="text-muted" style={{ fontSize: '0.7rem' }}>Pending</small>
          </div>
          <div className="text-center px-2 border-start">
            <div className="fw-bold text-success" style={{ fontSize: '1.2rem' }}>{completedCount}</div>
            <small className="text-muted" style={{ fontSize: '0.7rem' }}>Completed</small>
          </div>
          <div className="text-center px-2 border-start">
            <div className="fw-bold text-info" style={{ fontSize: '1.2rem' }}>
              {allDocuments.length > 0 
                ? Math.round((completedCount / allDocuments.length) * 100) 
                : 0}%
            </div>
            <small className="text-muted" style={{ fontSize: '0.7rem' }}>Rate</small>
          </div>
        </div>
      </Card.Body>
    </Card>
  );

  return (
    <>
    {permission.ManageView ? (
      <StaticListComponent
        columns={columns}
        data={allDocuments}
        bData={bData}
        MasterPageName="My Documents"
        noRecordCss="p-0"
        noRecordFound={
          <NoRecordTemplate
            headerValue="No Documents Found"
            subHeaderValue="You don't have any documents yet."
            imageUrl={StandardConst.imageNoRecordsFound}
          />
        }
        IsAddButtonVisible={false}
        isSearchRequired={true}
        allowSerialNo={true}
        customHeaderContent={<StatisticsCard />}
      />): (
      <Card className="shadow-sm mt-4 container">
        <Card.Body className="text-center p-4">
          <h5 className="text-danger mb-2">Access Denied</h5>
          <p className="text-muted mb-0">
            You do not have permission to view this page.
            Please contact your administrator.
          </p>
        </Card.Body>
      </Card>
    )}
    </>
  );
};

export default MyBroadcastDocuments; 